import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-security-section',
  templateUrl: './security-section.component.html',
  styleUrls: ['./security-section.component.scss']
})
export class SecuritySectionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
